import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import './informacion-adicional.css';

const InformacionAdicional = (props) => {
  const listaElementos = props.observaciones.filter((elemento) => elemento !== '');

  if (listaElementos.length === 0) return null;
  return (
    <div className='seccion'>
      <h3 className='titulo-seccion'>Informacion adicional</h3>
      <div className='panel panel-default custom bordeado info-extra'>
        <div className='panel-body'>
          {props.titulo}
          <br />
          <br />
          <div className='text-preformatted'>
            {ReactHtmlParser(listaElementos)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformacionAdicional;
